export const onlyNumbers = (value: string) => {
  const parsedValue = value.match(/\d+/g)?.join('')

  return parsedValue ? Number(parsedValue) : 0
}
